import { useEffect, useState } from 'react';

// Tailwind `sm` breakpoint: below 640px we treat the viewport as mobile.
const MOBILE_QUERY = '(max-width: 639px)';

/**
 * Returns `true` when the viewport is narrower than the `sm` breakpoint.
 * SSR-safe (returns `false` on the server). On the client, reads matchMedia
 * at first render so the initial value is already correct (no flash on
 * mount). The effect keeps the value in sync if the viewport is resized.
 * Mirrors the matchMedia pattern in `crochet-command-key-toggle.tsx`.
 */
export function useIsMobile(): boolean {
    const [isMobile, setIsMobile] = useState(
        () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(MOBILE_QUERY).matches,
    );

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            return;
        }
        const mql = window.matchMedia(MOBILE_QUERY);
        const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, []);

    return isMobile;
}
